/**
 * Route-level wrapper for the native survey builder (VER-109).
 *
 * BaseRoute mounts a bare `component` with no props, so the real persistence is injected here:
 * this container wires SurveyBuilderPage to the /survey-templates API (builder.apiPersistence).
 * SurveyBuilderPage itself keeps the in-memory mock as its default, so it still runs standalone
 * in unit tests without touching the network.
 */
import React from "react";
import SurveyBuilderPage from "./SurveyBuilderPage";
import { apiPersistence } from "./builder.apiPersistence";

const SurveyBuilderContainer = (): JSX.Element => <SurveyBuilderPage {...apiPersistence} />;

export default SurveyBuilderContainer;
